import React from 'react';
import apiclient from 'lib/apiclient';
import { useHistory } from 'react-router-dom';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { Formik, Form as FormikForm, Field} from 'formik';

const Table = (props) => {
  const {
    detail,
    onSubmit: handleSubmit
  } = props;

  return (
    <Formik initialValues={detail} onSubmit={handleSubmit}>
      {({values}) => (
      <Form tag={FormikForm}>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="autoUpgradeEnabled" />{' '}製品版自動アップグレード</Label>
        </FormGroup>
        <FormGroup check>
          <Label check><Input tag={Field} type="checkbox" name="upgradeNow" disabled={!values.autoUpgradeEnabled}/>{' '}30分後に自動アップグレードする</Label>
        </FormGroup>
        <FormGroup>
          <Label for="autoUpgradeFrom">自動アップグレード日</Label>
          <Input tag={Field} type="date" name="autoUpgradeFrom" disabled={!values.autoUpgradeEnabled || values.upgradeNow}/>
        </FormGroup>
        <Button>保存</Button>
      </Form> )}
    </Formik>
  );
}

export default (props) => {
  const [data, setData] = React.useState({});
  const history = useHistory();

  console.log(data);

  const id = props.match && props.match.params && props.match.params.id;
  const handleSubmit = React.useCallback((model) => {
    apiclient.post(`api/customer/${id}/upgrade`, model)
      .then(() => {
        history.goBack();
      });
  }, [id]);

  React.useEffect(() => {
    apiclient.get(`api/customer/${id}/upgrade`)
      .then(response => {
        if (response.data.autoUpgradeFrom == null) {
            response.data.autoUpgradeFrom = '';
        }
        setData({ detail: response.data, loaded: true });
      });
  }, [id]);

  const contents = data.loaded
    ? <Table detail={data.detail} onSubmit={handleSubmit} />
    : <p><em>Loading...</em></p>;

    return (
      <div>
        <h1 id="tabelLabel" ><span onClick={() => history.goBack()}>担当者一覧</span> &#12297; {id}</h1>
        {contents}
      </div>
    );
}